import { render, staticRenderFns } from "./CustomerOverview.vue?vue&type=template&id=71b4b898&scoped=true&"
import script from "./CustomerOverview.vue?vue&type=script&lang=js&"
export * from "./CustomerOverview.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOverview.vue?vue&type=style&index=0&id=71b4b898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b4b898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71b4b898')) {
      api.createRecord('71b4b898', component.options)
    } else {
      api.reload('71b4b898', component.options)
    }
    module.hot.accept("./CustomerOverview.vue?vue&type=template&id=71b4b898&scoped=true&", function () {
      api.rerender('71b4b898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Customer/CustomerOverview.vue"
export default component.exports